export default {
  props: {
    myDate: String,
    myCompany: Number
  },
  data: () => ({
    headers: [
      {
        text: 'Клиент',
        align: 'left',
        sortable: false,
        value: 'clientName'
      },
      { text: 'Телефон', value: 'clientPhone', sortable: false },
      { text: 'Услуга', value: 'serviceName' },
      { text: 'Сотрудник', value: 'staffName' },
      { text: 'Время записи', value: 'visitTime', align: 'center' },
      { text: 'Ссылка на запись', align: 'left', value: 'shortLink', sortable: false },
      { text: '', value: null, sortable: false }
    ],
    appointments: []
  }),
  watch: {
    myDate: function () {
      this.getAppointments()
    },
    myCompany: function () {
      this.getAppointments()
    }
  },
  created () {
    this.getAppointments()
  },
  methods: {
    getAppointments: function () {
      this.$http.get('/api/getAppointments/' + this.myCompany + '/' + this.myDate)
        .then(response => {
          this.appointments = response.data
        })
        .catch(error => {
          this.$store.dispatch('handleError', error.response)
        })
    },
    syncAppointments: function () {
      this.$http.post('/api/syncAppointments/' + this.myCompany + '/' + this.myDate)
        .then(response => {
          this.appointments = response.data
          this.$store.dispatch('showSuccessSnackbar', 'Записи синхронизированы')
        })
        .catch(error => {
          this.$store.dispatch('handleError', error.response)
        })
        .finally(() => {
          this.$emit('syncFinish')
        })
    },
    sendSms: function (yclientsId) {
      this.$http.post('/api/sendSingleSms/' + yclientsId + '/' + this.myCompany + '/' + this.myDate)
        .then(response => {
          this.appointments = response.data
          this.$store.dispatch('showSuccessSnackbar', 'Сообщение отправлено')
        })
        .catch(error => {
          this.$store.dispatch('handleError', error.response)
        })
    },
    sendSmsAll: function () {
      this.$http.post('/api/sendSmsAll/' + this.myCompany + '/' + this.myDate)
        .then(response => {
          this.appointments = response.data
          this.$store.dispatch('showSuccessSnackbar', 'Сообщения отправлены')
        })
        .catch(error => {
          this.$store.dispatch('handleError', error.response)
        })
        .finally(() => {
          this.$emit('smsAllFinish')
        })
    }
  }
}
